import {useTranslation} from 'react-i18next'
import {PhotoUploadField} from '@/components/photo-upload-field'
import {useUploadHallazgoFoto, type Hallazgo} from '@/hooks/sgsst/riesgos/use-entrevista'

/** `foto_hint` es la puerta: solo lo traen los hallazgos de una condición física que una foto capta. */
export function HallazgoFotoUpload({
  businessId,
  hallazgo,
  onUploaded,
}: {
  businessId: string
  // La tarjeta del inicio pasa `PendingHallazgoRead`, no el `Hallazgo` completo.
  hallazgo: Pick<Hallazgo, 'id' | 'foto_hint'>
  onUploaded?: () => void
}) {
  const {t} = useTranslation()
  const upload = useUploadHallazgoFoto(businessId)

  if (!hallazgo.foto_hint) return null

  return (
    <PhotoUploadField
      testId={`hallazgo-foto-${hallazgo.id}`}
      inputTestId="hallazgo-foto-input"
      buttonTestId="hallazgo-foto-upload"
      buttonLabel={t('entrevista.foto.action', {hint: hallazgo.foto_hint})}
      onUpload={(file, onProgress) => upload.mutateAsync({hallazgoId: hallazgo.id, file, onProgress})}
      onUploaded={onUploaded}
    />
  )
}
